/* MD reveal (architecture.md 4.9, CR-N-1). Bare [data-md-reveal] elements stay visible; this script arms
   (adds .md-reveal-wait to) only elements whose top is below the first viewport when it runs, so first-screen
   content and the LCP element are never hidden or animated. Elements marked data-md-lcp, inside an element
   marked data-md-lcp, or containing a data-md-lcp marker or an image with fetchpriority="high", are never armed. Both paths arm the same way:
   - animation-timeline: view() supported: html.md-tl, the CSS view timeline reveals armed elements;
   - otherwise: html.md-io, one IntersectionObserver adds .is-in.
   Reduced motion or no IntersectionObserver and no timeline: nothing is armed. */
(() => {
  if (window.mdMotion) return;
  window.mdMotion = true;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  const timeline = !!(window.CSS && CSS.supports && CSS.supports('animation-timeline: view()'));
  if (!timeline && !('IntersectionObserver' in window)) return;
  document.documentElement.classList.add(timeline ? 'md-tl' : 'md-io');

  const io = timeline
    ? null
    : new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-in');
            io.unobserve(entry.target);
          });
        },
        { threshold: 0.2, rootMargin: '0px 0px -10% 0px' }
      );

  /* CR-N-9: protected when the element is, contains, or sits inside the LCP marker, or contains a high-priority image */
  const protectedEl = (el) => !!el.closest('[data-md-lcp]') || !!el.querySelector('[data-md-lcp], img[fetchpriority="high"]');

  const arm = (root) => {
    root.querySelectorAll('[data-md-reveal-stagger]').forEach((parent) => {
      Array.from(parent.children).forEach((child, i) => {
        if (!child.style.getPropertyValue('--md-i')) child.style.setProperty('--md-i', i);
      });
    });
    const fold = window.innerHeight;
    root.querySelectorAll('[data-md-reveal]:not(.md-reveal-wait):not(.is-in)').forEach((el) => {
      if (protectedEl(el) || el.getBoundingClientRect().top < fold) return; /* stays visible, never armed */
      el.classList.add('md-reveal-wait');
      if (io) io.observe(el);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => arm(document));
  } else {
    arm(document);
  }
  document.addEventListener('shopify:section:load', (event) => arm(event.target));
})();
